import { render, staticRenderFns } from "./BaseReportScore.vue?vue&type=template&id=026e43d4"
import script from "./BaseReportScore.vue?vue&type=script&lang=js"
export * from "./BaseReportScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports